import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import Container from '@mui/material/Container';
import { Outlet } from 'react-router-dom';
import Copyright from './Copyright';

export const ContainerMain = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(8),
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
}));

const PublicLayout = () => (
  <Container component="main" maxWidth="xs">
    <ContainerMain>
      <Outlet />
    </ContainerMain>
    <Box mt={8}>
      <Copyright />
    </Box>
  </Container>
);

export default PublicLayout;
